export default __webpack_public_path__ + "static/media/key-function.6dc1b2ef.svg";